import React from 'react';
import { Home, Layout } from 'lucide-react';
import type { MantenedorTab } from '../types';

interface TabsProps {
    activeTab: MantenedorTab;
    onTabChange: (tab: MantenedorTab) => void;
}

export const MantenedoresTabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="px-4 sm:px-7 bg-white border-b border-gray-200 flex overflow-x-auto hide-scrollbar shrink-0">
            <div className="flex space-x-6">
                <button
                    onClick={() => onTabChange('propiedad')}
                    className={`flex items-center gap-2 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'propiedad'
                            ? 'border-[#4f6df5] text-[#4f6df5]'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                >
                    <Home size={16} />
                    Tipo de Propiedad
                </button>
                <button
                    onClick={() => onTabChange('alojamiento')}
                    className={`flex items-center gap-2 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'alojamiento'
                            ? 'border-[#4f6df5] text-[#4f6df5]'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                >
                    <Layout size={16} />
                    Tipo de Alojamiento
                </button>

                {/* NUEVO BOTÓN: Facturación SIAT */}
                <button
                    onClick={() => onTabChange('facturacion')}
                    className={`py-3 px-6 text-sm font-medium border-b-2 transition-colors ${activeTab === 'facturacion'
                            ? 'border-blue-600 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                >
                    Datos de Facturación JOM
                </button>
            </div>
        </div>
    );
};